import {
  getCrmLabel,
  RiskScoreEnum,
  TransactionOwnerEnum,
  TransactionStatusEnum,
  TransactionTypeEnum,
  TransactionWalletProviderEnum,
  TransactionWalletScopeEnum,
} from '@sparling/financial-common'
import { IColumns } from '../../../components/Table'

export type UserTransactionColumnsType =
  | 'id'
  | 'type'
  | 'asset'
  | 'amount'
  | 'riskScore'
  | 'status'
  | 'createdAt'
  | 'actions'

export const columnsUserTransaction: IColumns<UserTransactionColumnsType>[] = [
  {
    id: 'id',
    label: 'Transaction ID',
  },
  {
    id: 'type',
    label: 'Type',
    format: (value) =>
      value
        ?.toString()
        .replace('_', ' ')
        .replace(/\b[a-z]/g, (match: string) => match.toUpperCase()) || '-',
  },
  {
    id: 'asset',
    label: 'Asset',
  },
  {
    id: 'amount',
    label: 'Amount',
  },
  {
    id: 'riskScore',
    label: 'Risk Score',
  },
  {
    id: 'status',
    label: 'Status',
    format: (status: unknown, owner?: unknown, type?: unknown, score?: unknown): string | null => {
      return getCrmLabel(
        owner as TransactionOwnerEnum,
        status as TransactionStatusEnum,
        type as TransactionTypeEnum,
        TransactionWalletProviderEnum.FIREBLOCKS,
        TransactionWalletScopeEnum.INTERNAL,
        score as RiskScoreEnum,
      )
    },
  },
  {
    id: 'createdAt',
    label: 'Created',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
  {
    id: 'actions',
    label: 'ACTION',
  },
]

export type FinanceTransactionColumnsType =
  | 'id'
  | 'userId'
  | 'type'
  | 'asset'
  | 'amount'
  | 'riskScore'
  | 'status'
  | 'createdAt'
  | 'actions'

export const columnsFinanceTransaction: IColumns<FinanceTransactionColumnsType>[] = [
  {
    id: 'id',
    label: 'Instrument ID',
  },
  {
    id: 'userId',
    label: 'User ID',
  },
  {
    id: 'type',
    label: 'Type',
    format: (value) =>
      value
        ?.toString()
        .replace('_', ' ')
        .replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
  },
  {
    id: 'asset',
    label: 'Asset',
  },
  {
    id: 'amount',
    label: 'Amount',
  },
  {
    id: 'riskScore',
    label: 'Risk Score',
  },
  {
    id: 'status',
    label: 'Status',
    format: (status, owner, type, score) =>
      getCrmLabel(
        owner as TransactionOwnerEnum,
        status as TransactionStatusEnum,
        type as TransactionTypeEnum,
        TransactionWalletProviderEnum.FIREBLOCKS,
        TransactionWalletScopeEnum.INTERNAL,
        score as RiskScoreEnum,
      ),
  },
  {
    id: 'createdAt',
    label: 'Created',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
  {
    id: 'actions',
    label: 'ACTION',
  },
]
